import SquareTimerRing from './SquareTimerRing';

interface Props {
    seconds: number;
    max?: number;
}

const CoinflipMiniTimer = ({ seconds, max = 15 }: Props) => {
    return (
        <div
            className="w-[50px] h-[50px] relative grid place-items-center shrink-0 rounded-[28%]"
            style={{ background: 'rgba(255,255,255,0.03)' }}
        >
            {/* soft round halo (replaces the old square glow) */}
            <span
                aria-hidden
                className="absolute inset-0 rounded-full blur-[9px] -z-[1] pointer-events-none"
                style={{ background: 'radial-gradient(circle, rgba(58,214,255,0.4), transparent 70%)' }}
            />
            <SquareTimerRing seconds={seconds} max={max} size={50} stroke={3.5} radius={14} />
            <span
                className="font-chat-nick relative text-[16px] font-extrabold text-white tabular-nums"
                style={{ textShadow: '0 0 10px rgba(58,214,255,0.6)' }}
            >
                {seconds}
            </span>
        </div>
    );
};

export default CoinflipMiniTimer;
